export default "/assets/thumbs_down-27d1ea1e6a84caaf70fd10f56015acd2f131f3b47602d92fdf3a9fbe7acacd56.svg";